import React from 'react'
import Maintenance from '../../../Component/Maintenance'

const MaintenanceMode = () => {
    return <Maintenance />
}

export default MaintenanceMode
